// extracted by mini-css-extract-plugin
module.exports = {"iframe":"_1LpJM","screenWidth":"_1nYA0"};